export default {
    index: {
        listagem_unidades: 'Listagem de Unidades',
        unidade_nao_encontrada: 'Nenhuma Unidade encontrada',
        criar_unidade: 'Criar unidade',
        editar: 'Editar',
        nome: 'Nome',
        apelido: 'Apelido'
    },
    form: {
        unidades: 'Unidades',
        empresa_principal: 'Empresa Principal',
        informacoes: 'Informações',
        nome: 'Nome',
        nome_descricao: 'Nome da Unidade',
        mnemonico: 'Mnemônico',
        mnemonico_descricao: 'Mnemônico da Unidade',
        veus_id_descricao: 'ID da Unidade no Veus Saúde',
        vinculo: 'Vínculo',        
        empresa_principal_descricao: 'Empresa Principal',
        unidade_criada_sucesso: 'Unidade criada com sucesso!',
        unidade_atualizada_sucesso: 'Unidade atualizada com sucesso!'
    }
}